export const SET_OBJECTIVES = "OBJECTIVE/SET_OBJECTIVES";
export const SET_OBJECTIVE = "OBJECTIVE/SET_OBJECTIVE";
export const SET_PAGINATION = "OBJECTIVE/SET_PAGINATION";
export const SET_ODS = "OBJECTIVE/SET_ODS";
export const SET_MEASURES = "OBJECTIVE/SET_MEASURES";


